// src/utils/cacheService.js
export default {
    cache: new Map(),
    
    // 获取缓存数据
    get(key) {
      return this.cache.get(key);
    },
    
    // 设置缓存数据
    set(key, value) {
      this.cache.set(key, value);
    },
    
    // 清除缓存
    clear(key) {
      this.cache.delete(key);
    },
    
    // 判断缓存是否存在
    has(key) {
      return this.cache.has(key);
    }
  }